import React, { Fragment } from 'react'
import { useMemo } from 'sb-hooks'
import cx from 'classnames'

import { Image } from 'components/_new/ui'

import s from './FragranceSearchOption.scss'


type FragranceSearchOptionProps = {
  className?: string
  img: string
  title: string
  query: string
}


const FragranceSearchOption: React.FunctionComponent<FragranceSearchOptionProps> = ({ className, title, img, query }) => {
  const displayTitle = useMemo(() => {
    const filteredQuery      = query.replace(/[^\w\s-.']/g, '').trim().toLowerCase()
    const intersectionBegin  = title.toLowerCase().indexOf(filteredQuery)
    const hasIntersection    = intersectionBegin > -1 && filteredQuery.length > 0

    if (hasIntersection) {
      const intersectionEnd  = intersectionBegin + filteredQuery.length
      const begin            = title.substring(0, intersectionBegin)
      const intersection     = title.substring(intersectionBegin, intersectionEnd)
      const end              = title.substring(intersectionEnd)

      return (
        <Fragment>
          {begin}
          <span className={s.intersection}>{intersection}</span>
          {end}
        </Fragment>
      )
    }

    return (
      <Fragment>
        {title}
      </Fragment>
    )
  }, [ query, title ])

  return (
    <div className={cx(s.option, className)}>
      <Image className={s.image} h={50} src={img} alt={title} x2 resizeBy="width" />
      <div className={s.text}>{displayTitle}</div>
    </div>
  )
}


export default FragranceSearchOption
